export const eventCTA = () => {
    // Page (sections)
    const sections = document.querySelectorAll('section.block') as NodeListOf<HTMLElement>;
    sections.forEach(section => {
        const emplacement = section.getAttribute('data-block') || 'Page';

        const buttons = section.querySelectorAll('a.btn:not(.card__btn):not(.btn-contact)') as NodeListOf<HTMLElement>;
        buttons.forEach(button => {
            attachClickTracking(button, emplacement);
        });
    });

    function attachClickTracking(button: HTMLElement, location: string) {
        button.addEventListener('click', () => {
            const nomCTA = button.textContent?.trim() || 'na';
            const nomBloc = button.closest("section")?.querySelector("h2")?.textContent?.trim() ?? "na";
            const pageType = document.body.getAttribute("data-pagetype");

            // Exclude href.
            const url = button.getAttribute("href");
            if (url && url.includes("/demandez-un-devis")) {
                return;
            }

            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                emplacementCTA: location,
                nomCTA: nomCTA,
                nomBloc: nomBloc,
                pageType: pageType,
                event: 'clicCTA'
            });
        });
    }
}
